module.exports = __webpack_public_path__ + "assets/img/order.fb7f239d.svg";